import OfficeHelper from './ModelHelpers/OfficeHelper';
import stringHelper from './stringHelper';
import { toDateOnlyString } from '../Domain/OutsourcedUserFte/outsourcedUserFteHelpers';

export default class ValidityHelper {
  static forRequiredTextField(e) {
    if (!e || e.toString().trim() === '') return "This field can't be empty.";
    return '';
  }

  // For FileUploadField values (a File object or null) — same required check,
  // file-appropriate message (matches the Add New Attachment modal's wording).
  static forRequiredFileField(e) {
    if (!e) return 'You have to select a file!';
    return '';
  }

  static forRequiredUrlTextField(e) {
    if (!e || e.toString().trim() === '') return "This field can't be empty.";
    //Check if 'e' starts with http:// or https://
    if (!e.startsWith('http://') && !e.startsWith('https://')) {
      return 'The URL has to be started with http:// or https://';
    }

    try {
      const url = new URL(e);
      return '';
    } catch {
      return 'This field must be a valid URL.';
    }
  }

  static forMaximizedLengthField(e, maxLength) {
    if (e && e.length > maxLength)
      return `This field can't store more than ${stringHelper.numberWithLetter(maxLength, false)} characters.`;
    return '';
  }

  static forMinimumLengthField(e, minLength) {
    if (e && e.length < minLength)
      return `This field must be at least ${stringHelper.numberWithLetter(minLength, false)} characters long.`;
    return '';
  }

  static forRequiredAndMaxLengthField(e, maxLength) {
    if (!e || e.toString().trim() === '') return "This field can't be empty.";
    if (e && e.length > maxLength)
      return `This field can't store more than ${stringHelper.numberWithLetter(maxLength, false)} characters.`;
    return '';
  }

  static forNotRequiredPhoneNumber(e) {
    if (e === '' || e === undefined) return '';
    const parts = e.split(')-');
    if (parts.length < 2) return "Phone number isn't correct.";
    if (parts[0].trim() === '' || parts[1].trim() === '') return "These fields can't be empty.";
    return '';
  }

  static forRequiredPhoneNumber(e) {
    const parts = e.split(')-');
    if (parts.length < 2) return "Phone number isn't correct.";
    if (parts[0].trim() === '' || parts[1].trim() === '') return "These fields can't be empty.";
    return '';
  }

  static forRequiredBareManagerPhoneNumber(e, editedItem) {
    if (editedItem.PhoneNumberOverride === 'true') {
      const parts = editedItem.PhoneNumberOverrideValue.split(')-');
      if (parts.length < 2) return "Phone number isn't correct.";
      if (parts[0].trim() === '' || parts[1].trim() === '') return "These fields can't be empty.";
    }

    return '';
  }

  static forRequiredBoolField(e) {
    if (e !== 'true' && e !== 'false' && e !== true && e !== false) return "This field can't be empty.";
    return '';
  }

  static forRequiredNumberFieldGreaterThanZero(e) {
    if (e <= 0) return 'This value has to be more than zero. ';
    return '';
  }

  static forRequiredIntegerGreaterThanZero(e) {
    e = parseInt(e);
    if (!e || e <= 0) return 'This value has to be more than zero. ';
    return '';
  }

  static forRequiredNumberField(e) {
    if (e < -1000 || e > 1000) return 'This value has to be a number. ';
    return '';
  }

  static forRequiredNumberFieldAtLeastZero(e) {
    if (e < 0) return 'This value has to be at least zero. ';
    return '';
  }

  static forRequiredNumberFieldMinZeroMaxOneHundred(e) {
    if (e < 0 || e > 100) return 'This value has to be between 0 and 100. (0 <= X <= 100) ';
    return '';
  }

  static forRequiredSelectField(e) {
    if (!e || parseInt(e) <= 0) return "This field can't be empty. ";
    return '';
  }

  static forCreditMemoRequestReasonChange(e, editedItem) {
    const reasonCode = parseInt(editedItem.ReasonCode);
    const oldReasonCode = parseInt(editedItem.OldReasonCode);
    const lineItemCount = parseInt(editedItem.LineItemCount);

    if (!reasonCode || reasonCode <= 0) return "This field can't be empty. ";

    if (oldReasonCode != reasonCode && (oldReasonCode === 7 || reasonCode === 7) && lineItemCount > 0) {
      return 'Unable to change Credit Memo reason to or from Late Fee Credit. Please unapply credit from the invoice line items before proceeding.';
    }

    if (oldReasonCode != reasonCode && (oldReasonCode === 8 || reasonCode === 8) && lineItemCount > 0) {
      return 'Unable to change Credit Memo reason to or from Tax Credit. Please unapply credit from the invoice line items before proceeding.';
    }

    return '';
  }

  static forRequiredMultiSelectField(e) {
    if ((Array.isArray(e) && e.length == 0) || !e || parseInt(e) <= 0) return "This field can't be empty. ";
    return '';
  }

  static forEmailNotRequired(e) {
    if (e === '' || e == undefined) return '';
    return ValidityHelper.forEmailRequired(e);
  }

  static forEmailRequired(e) {
    const res = ValidityHelper.forRequiredTextField(e);
    if (res !== '') {
      return res;
    }
    const addresses = e.split(';');
    const mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+[.]+[a-zA-Z0-9-]/;
    for (const email of addresses) {
      if (!mailformat.test(email)) return "The email address isn't correct.";
    }

    return '';
  }

  static AlwaysFlawless(e) {
    return '';
  }

  static emptyValidityChecker(text, value) {
    return '';
  }

  static forRequiredDateTime(e) {
    //The e is in format of 'yyyy-MM-dd HH:mm'
    if (!e || e.toString().trim() === '') return "This field can't be empty.";
    const dateTimeFormat = /^\d{4}-\d{2}-\d{2} ([01]\d|2[0-3]):([0-5]\d)$/;
    if (!dateTimeFormat.test(e)) return "The date and time must be in 'YYYY-MM-DD HH:MM' format.";
    return '';
  }

  static forDateTimeOrEmpty(e) {
    //The e is in format of 'yyyy-MM-dd HH:mm'
    if (!e || e.toString().trim() === '') return '';
    const dateTimeFormat = /^\d{4}-\d{2}-\d{2} ([01]\d|2[0-3]):([0-5]\d)$/;
    if (!dateTimeFormat.test(e)) return "The date and time must be in 'YYYY-MM-DD HH:MM' format.";
    return '';
  }

  static forRequiredTime(e) {
    if (!e || e.toString().trim() === '') return "This field can't be empty.";
    const timeFormat = /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/;
    if (!timeFormat.test(e)) return 'The time must be in HH:MM format.';
    return '';
  }

  static forRequiredDateLatterThanToday(e) {
    const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    if (e < today || e === 'NaN-NaN-NaN') {
      return "The date can't be before today.";
    }

    return '';
  }

  static forRequiredDateTimeLaterThanToday(e) {
    e = new Date(e);
    const date = Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate());
    const today = Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate());
    if (date <= today || e === 'NaN-NaN-NaN') {
      return "The date can't be today or before.";
    }

    return '';
  }

  static forRequiredDateTodayOrLater(e) {
    const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1, 23, 59, 59);
    if (e < today || e === 'NaN-NaN-NaN') {
      return "The date can't be before today.";
    }

    return '';
  }

  static forTextLenghtCheck(text, value) {
    if (text.length !== value || !text.match(/^[A-Za-z]+$/)) return `Must be ${value} letters`;
    return '';
  }

  static forNumberLengthCheck(number, value) {
    if (!number || number.toString().length !== value || !number.toString().match(/^[0-9]+$/))
      return `Must be ${value} digits`;
    return '';
  }

  static validityCheckerforVatNumber(e, editedItem) {
    if (editedItem === undefined) return '';
    if (!stringHelper.onlyLettersAndNumbers(e))
      return "This field can't contain anything else except numbers and letters.";
    if (!OfficeHelper.IsEUOffice(editedItem.OfficeId)) return '';
    if (!e || e.toString().trim() === '') return "This field can't be empty.";
    return '';
  }

  static forClientMatchCheck(e, editedItem) {
    if (e && editedItem.ClientId.toString() === e.toString()) return `The client can't be its own parent.`;
    return ValidityHelper.forRequiredSelectField(e);
  }

  // TP Evaluator linking dialog: the picked profile must exist and must not be the primary row itself.
  static forTpEvaluatorAttachCheck(e, editedItem) {
    if (e && `${editedItem.PrimaryTpEvaluatorId}` === `${e}`) return `A TP Evaluator can't be linked to itself.`;
    return ValidityHelper.forRequiredSelectField(e);
  }

  // An FTE entry is invoiced as a single calendar month, so its start and end
  // dates must fall within the same calendar month and year. Mirrors the backend
  // guard in OutsourcedUserFteTools.ValidateWithinSingleCalendarMonth.
  static forFteEndDateWithinStartMonth(endValue, editedItem) {
    const required = ValidityHelper.forRequiredTextField(endValue);
    if (required !== '') return required;

    const start = toDateOnlyString(editedItem.StartDateUtc);
    const end = toDateOnlyString(endValue);
    if (!start || !end) return '';

    if (start.slice(0, 7) !== end.slice(0, 7)) {
      return 'An FTE entry cannot span more than one month. The start and end dates must fall within the same calendar month.';
    }

    return '';
  }

  // Required + the Hiring Office (billing-from) and Fieldwork Office (billing-to) must differ.
  // Attached to both office fields; compares item.FieldworkOfficeId vs item.HiringOfficeId.
  // Mirrors the backend guard OutsourcedUserFteTools.ValidateFieldworkDifferentFromHiringOffice.
  static forDifferentFieldworkAndHiringOffice(e, editedItem) {
    const required = ValidityHelper.forRequiredSelectField(e);
    if (required !== '') return required;

    if (
      editedItem &&
      editedItem.FieldworkOfficeId &&
      editedItem.HiringOfficeId &&
      String(editedItem.FieldworkOfficeId) === String(editedItem.HiringOfficeId)
    ) {
      return 'The Hiring Office and the Fieldwork Office cannot be the same.';
    }
    return '';
  }

  static forOptionalColorField(e, editedItem) {
    if (e) {
      if (CSS.supports('color', e)) {
        return '';
      }
      return 'The color is not valid.';
    }
    return '';
  }
}
